export class DomainBrokerType {
    name: string;
    id_origem: string;
    filtro?: string;

    constructor(_name, _idOrigem, _filtro?) {
        this.name = _name;
        this.id_origem = _idOrigem;
        this.filtro = _filtro;
    }

}
